import React, { Component } from 'react'
import style from './style.css'
import { Select } from '../../atoms/Forms'
import Font from '../../atoms/Font'
import ImageRatio from '../../atoms/ImageRatio'
import { Col, Row } from '../../../SPRINTA/atoms/Grid'
import Modal from '../../../SPRINTA/atoms/Modal'
import ActionBtnIcon from '../../../SPRINTA/molecules/ActionBtnIcon'
import T from '../../../SPRINTA/translate/T'


class ServiceBox extends Component {

    state = {
        maxQuantity: 0,
        qtdy: 0,
        optionId: null,
        limit: 0,
        // modalActive: false
    }

    componentDidMount() {
        this.quantity = true
        if(this.props.mandatory === "1" && this.props.limit === "1") {
            this.handleChangeQtdy({
                target: {
                    name: this.props.name,
                    value: 1
                }
            })
            this.quantity = false
        }

        this.setState({
            maxQuantity: this.props.limit,
            limit: this.props.limit
        })
    }

    handleChangeQtdy( e ) {
        this.setState({
            qtdy: e.target.value
        })
        this.props.onChange(e)
    }

    handleChangeOption( e ) {
        let optinx = this.props.options.find( option => option.id === e.target.value )
        if(optinx) {
            optinx.quantity = parseInt(optinx.quantity, 10)

            let qtdy = Math.min(this.state.limit, optinx.quantity)

            if(qtdy < this.state.qtdy) {
                this.handleChangeQtdy({
                    target: {
                        name: this.props.name,
                        value: qtdy
                    }
                })
            }

            if(this.state.qtdy === 0) {
                this.handleChangeQtdy({
                    target: {
                        name: this.props.name,
                        value: 1
                    }
                })
            }

            this.setState({
                optionId: e.target.value,
                maxQuantity: qtdy
            })
        } else {
            this.setState({
                optionId: '',
                maxQuantity: this.state.qtdy
            })

            this.handleChangeQtdy({
                target: {
                    name: this.props.name,
                    value: 0
                }
            })
        }
        this.props.onChangeOption(e)
    }

    handleOpenModal() {
        this.props.handleModal({
            image: this.props.image || require('./imagemNull.jpg'),
            description: this.props.description,
            price: this.props.price,
            title: this.props.title
        })
    }

    render() {
        let options = []

        for (var i = 1; i <= this.state.maxQuantity; i++) {
            options.push(
                <option key={i} value={i}>{i}</option>
            )
        }

        let showOptions = this.props.options ? true : false
        let showLimits = this.props.limit && (this.props.limit > 1 || this.props.mandatory === "0") ? true : false
        let image = this.props.image || require('./imagemNull.jpg')
        return (
            <div className={`${style.box}`}>
                <div>
                    <div style={{marginBottom: '20px', cursor: 'pointer', position: 'relative'}} onClick={() => this.handleOpenModal()}>
                        <ActionBtnIcon
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                zIndex: 9
                            }}
                            icon='search'
                            theme='rounded-orange' />
                        <ImageRatio image={image} ratio='1x1' />
                    </div>

                    <div className={style.boxContent} style={{height: '230px'}}>
                        <div className={`${style.titleContent}`}>
                            <div className={`${style.title}`} style={{textTransform: 'uppercase'}}>
                                {this.props.title}
                            </div>
                        </div>

                        <div className={style.descriptionContent} style={{height: '100px'}}>
                            <div className={style.description}>
                                {this.props.description && (
                                    <span>
                                        {
                                            this.props.description.length > 110 ? this.props.description.slice(0, 107) + '... ' : this.props.description
                                        }
                                        {this.props.description.length > 110 && (
                                            <span className={style.link} style={{cursor: 'pointer'}} onClick={ () => this.handleOpenModal() }>({T.text('see_more')})</span>
                                        )}
                                    </span>
                                )}
                            </div>
                        </div>

                        {this.props.fullPrice ? (
                        <div style={{ fontSize: '16px'}}>
                        <p>De  <span style={{ textDecoration:'line-through'}}>{this.props.fullPrice }</span> por</p> 
                        </div>
                        ) : ''}
                        <div style={{
                                float: 'left',
                                width: '100%',
                                height: '50px'
                            }}>
                           
                            <Font heading="5" weight="100">{this.props.price}</Font>
                        </div>


                        {showOptions && (
                            <Col size='12' gutter='small'>
                                <div className={style.selectBox}>
                                    <Select name={this.props.name} value={this.props.option_value || ""} handleChange={(e) => this.handleChangeOption(e)}>
                                        <option value="">{this.props.options_label}</option>
                                        {this.props.options.map( i => (
                                            <option key={i.id} value={i.id}>{i.label}</option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>

                        )}

                        {showLimits && (
                            <Col size='12' gutter='small'>
                                <div className={style.selectBox}>
                                    <Select name={this.props.name} value={this.props.value || ''} handleChange={(e) => this.handleChangeQtdy( e )}>
                                        <option value={0}>{options.length > 0 || this.props.option_value === '' ? T.txt('qty') : T.txt('unavailable')}</option>
                                        {options}
                                    </Select>
                                </div>
                            </Col>
                        )}
                    </div>
                </div>
            </div>
        )
    }
  }

  export const ModalService = props => {

        let data = {
            image: null,
            price: null,
            title: null,
            description: null
        }

        if(props.data) {
            data = props.data
        }


        return (
          <Modal
              style={{width: '600px', padding: '0 0 40px 0'}}
              active={props.active}
              handleClose={ () => props.handleClose()}
              >
              <Row>
                  <Col size='12' float='center' text='center'>
                      <img className={style.imgFull} src={data.image} alt='product' />
                  </Col>
              </Row>

              <Col size='12 10' float='center'>
                  <div className={style.modal_title}>
                      {data.title}
                  </div>

                  <div className={style.modal_description}>
                      {data.description}
                  </div>

                  <div style={{marginTop: '30px', textAlign: 'center'}}>
                      <Font heading="5" weight="100">{data.price}</Font>
                  </div>

              </Col>

          </Modal>
        )

  }

  export default ServiceBox



// WEBPACK FOOTER //
// ./src/components/molecules/ServiceBox2/index.js